import { render, staticRenderFns } from "./ImageBrowser.vue?vue&type=template&id=5d894586&scoped=true&"
import script from "./ImageBrowser.vue?vue&type=script&lang=js&"
export * from "./ImageBrowser.vue?vue&type=script&lang=js&"
import style0 from "./ImageBrowser.vue?vue&type=style&index=0&id=5d894586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d894586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d894586')) {
      api.createRecord('5d894586', component.options)
    } else {
      api.reload('5d894586', component.options)
    }
    module.hot.accept("./ImageBrowser.vue?vue&type=template&id=5d894586&scoped=true&", function () {
      api.rerender('5d894586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/ImageBrowser.vue"
export default component.exports